<div class="carousel" #carouselContainer>
  <div class="carousel-track" [style.transform]="transform">
    <div class="carousel-item" *ngFor="let item of displayedItems">
      <img [src]="item.image" alt="Carousel image">

      <div class="carousel-content">
        <h2>{{ item.title }}</h2>
        <p>{{ item.description }}</p>

        <div class="carousel-action">
          <a *ngIf="item.link" [href]="item.link" target="_blank" rel="noopener">
            <button>Tovább</button>
          </a>
        </div>
      </div>
    </div>
  </div>

  <button class="prev" (click)="prev()">&#10094;</button>
  <button class="next" (click)="next()">&#10095;</button>
</div>
